import { colors } from '../../Colors/colors'

export const tableViewTheme = {
   light: {
      bulkActions: {
         popoverBgColor: 'bg-white',
         popoverBorderColor: 'border-gray-300',
         selectedTextColor: 'text-primary-600',
         xCloseIconColor: colors['gray-400'],
         verticalLineColor: 'bg-gray-300',
         checkSquareIconColor: colors['primary-600'],
         hrLineColor: 'bg-gray-300',
         assigneeBulkUpdate: {
            popoverBorderColor: 'border-gray-300',
            popoverBgColor: 'bg-base-white',
            iconStrokeColor: colors['gray-700'],
            sendNotificationTextColor: 'text-gray-600',
            knobLeftBGColor: colors['gray-100'],
            assigneeCustomOptionBgColor: 'bg-gray-50',
            assigneeCustomOptionTextColor: 'text-gray-900',
            checkIconColor: colors['primary-600']
         },
         initiateDealBulkAction: {
            rockerIconColor: colors['gray-700']
         },
         pinBulkAction: {
            textColor: 'text-gray-600',
            tooltipBgColor: 'bg-gray-900',
            tooltipArrowColor: colors['gray-900']
         }
      },
      whatsappIntegrations: {
         labelTextColor: 'text-gray-600',
         fieldNameColor: 'text-gray-700',
         messageTemplates: {
            eyeIconColor: colors['primary-600'],
            cardBorderColor: 'border-gray-300',
            templateNameColor: 'text-gray-700',
            templateContentColor: 'text-gray-500',
            dividerBgColor: 'bg-gray-300'
         },
         resultView: {
            recordNameColor: 'text-gray-700',
            phoneNumberColor: 'text-gray-500',
            failureReasonColor: 'text-error-500',
            titleColor: 'text-gray-800',
            descriptionColor: 'text-gray-500'
         }
      },
      table: {
         actions: {
            headerColor: 'text-gray-600',
            hieColumnIconColor: colors['gray-700'],
            actionsLabelColor: 'text-gray-700',
            actionBgOnHover: 'hover:bg-gray-50',
            resizerHoverStyles: 'hover:bg-primary-400'
         }
      },
      uploadedFilesList: {
         uploadedFileTextColor: 'text-gray-600',
         uploadedFileListTypeTextColor: 'text-gray-900',
         uploadedFileIconColor: colors['gray-500']
      }
   },
   dark: {}
}
